export default __webpack_public_path__ + "static/media/enhancedWebsiteSample3.06819a39.png";